import { PhoneNumberType } from '@navio/nsdk';
import { NoddiIconName } from 'noddi-ui-common';
import { type FilterOption } from 'noddi-ui-web';
import { PHONE_NUMBER_TYPE_OPTIONS } from 'noddi-util';

const phoneNumberTypeIconMap: Record<PhoneNumberType, NoddiIconName> = {
  [PhoneNumberType.MOBILE]: 'Phone',
  [PhoneNumberType.LANDLINE]: 'Building2',
  [PhoneNumberType.SPECIAL]: 'Zap',
  [PhoneNumberType.UNKNOWN]: 'CircleHelp'
};

export const PHONE_NUMBER_TYPE_FILTER_OPTIONS: FilterOption<PhoneNumberType>[] = PHONE_NUMBER_TYPE_OPTIONS.map(
  (opt) => ({
    ...opt,
    icon: phoneNumberTypeIconMap[opt.value]
  })
);
